import { SxProps, Theme } from '@mui/material'

type MasterSelectorStylesType = {
  container: SxProps<Theme>
  autocomplete: SxProps<Theme>
}

export const masterSelectorStyles: MasterSelectorStylesType = {
  container: {
    mx: 2,
  },
  autocomplete: {
    width: '100%',
    '& .MuiAutocomplete-input': {
      typography: 'body1',
    },
  },
}
